import BaseTableRow from '@material-ui/core/TableRow'

const TableRow = BaseTableRow

export default TableRow
